import { ParametrosWSBase, DestinoConexion } from "../../../ParametrosWSBase";
import { EncabezadoRespuestaInterna } from "../../../EncabezadoRespuestaInterna";

export function CodeValidationRegistration_Parametros(
  datos: any,
  p_crc: string | null
) {
  var par: ParametrosWSBase = {
    nombreProceso: "CodeValidationRegistration",
    rutaEndPoint: "/izzi/registro/verificar-codigo",
    sistemaOrigen: "SEL",
    AGREGAR_ENCABEZADO: true,
    DESTINO_SERVICIO: DestinoConexion.Proxy,
    parametros: { ...datos },
    cRC: p_crc,
  };

  return par;
}

//ENTRADA

export interface CodeValidationRegistration_Request {
  numberContract: string;
  verificationCode: string;
}

export function builtCodeValidationRegistrationRequest(
  p_numbercontract: string,
  p_verificationcode: string
) {
  var retorno: CodeValidationRegistration_Request = {
    numberContract: p_numbercontract,
    verificationCode: p_verificationcode,
  };

  return retorno;
}

//SALIDA

//export interface CodeValidationRegistration_Response {
//  code: string;
//  message: string;
//}



export interface CodeValidationRegistration_Response {
  code:          string;
  message:       string;
  izziErrorCode: string;
  response:      Response;
}

export interface Response {
  message: string;
}

